<template>
  <div>
    <navbar fixed back bg>
      <span slot="title">选择城市</span>
    </navbar>
    <div class="page-content">
      <div class="present">
        <span class="present-item">当前城市</span>
        <span class="city-name">{{cityName}}</span>
      </div>
      <div class="city">
        <p class="city-title">热门城市</p>
        <ul class="city-group">
          <li class="city-item" v-for="(item, index) in cityList" @click="onSelect(index)" :key="index">{{item.cityName}}</li>
        </ul>
      </div>
      <spinner :show="loading"></spinner>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        cityName: '',
        loading: false,
        cityList: []
      }
    },
    components: {Navbar, Spinner},
    created () {
      this.cityName = this.$cache.getCity().name
      this._fetchData()
    },
    methods: {
      _fetchData () {
        let vm = this
        this.loading = true
        this.$ajax({
          url: '/getCitys.jhtml',
          params: {
            cityNo: vm.$cache.getCity().code
          },
          done (list) {
            vm.cityList = list || []
          },
          fail (msg) {
            vm.$dialog(msg)
          },
          always (response) {
            vm.loading = false
          }
        })
      },
      onSelect (index) {
        let item = this.cityList[index]
        this.$cache.setCity({
          code: item.cityCode,
          name: item.cityName,
          remarks: item.hotline
        })
        this.$router.back()
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .present
    margin-top px2rem(20)
    padding 0 1em
    font-size px2rem(28)
    line-height 2.9
    background-color #fff
    box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)

    .present-item
      padding-right px2rem(20)
      color #275482

    .city-name
      padding-left px2rem(20)
      color #40a3fb
      border-left 1px solid #eff6fd

   .city
     text-align center

    .city-title
      margin-top px2rem(44)
      margin-bottom px2rem(28)
      font-size px2rem(28)
      color #40a3fb

    .city-group
      margin 0
      padding 0
      font-size 0
      list-style-type none

      .city-item
        display inline-block
        margin 0 px2rem(8) px2rem(28)
        padding px2rem(22) 0
        width px2rem(224)
        font-size px2rem(32)
        color #fff
        border-radius px2rem(8)
        background-color #40a3fb
        box-shadow 0 0 px2rem(4) rgba(18,119,163, .75)
</style>



// WEBPACK FOOTER //
// city.vue?fb389eb2